'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _iBem = require('../../i-bem/i-bem.react');

exports.default = (0, _iBem.decl)({
    block: 'copyright',
    elem: 'dates',
    tag: 'span',
    content: function content() {
        var start = this.props.start,
            currentYear = new Date().getFullYear();


        return [start && start !== currentYear && start + '–', currentYear];
    }
});